import React, { useCallback, useEffect } from 'react'
import { useAppSelector } from './ReduxHooks'
import { AbwaabLogoIcon } from '@Assets/Brand'

type Args = {
	auto?: boolean
}

/** One HTML template serves both hosts — staging identifies itself by hostname. */
const isStagingHost = () => /^stag\./i.test(window.location.hostname)

export const useBrowserTabInit = ({ auto = true }: Args) => {
	const { assets, meta } = useAppSelector(s => s.settings)
	useEffect(() => {
		if (auto) updateFavicon()
	}, [assets.favicon])

	useEffect(() => {
		if (auto) updateDocumentTitle()
	}, [meta?.title])

	const updateFavicon = useCallback(() => {
		let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement
		if (!link) {
			link = document.createElement('link')
			link.rel = 'icon'
			document.getElementsByTagName('head')[0].appendChild(link)
		}

		// Force the AbwaabPlus icon regardless of the (still Eduact) backend asset.
		link.href = AbwaabLogoIcon
	}, [])

	const updateDocumentTitle = useCallback(() => {
		// Rebrand the backend title (e.g. "Eduact Staging" → "Abwaab Staging").
		const title = meta?.title ? meta.title.replace(/eduact/gi, 'Abwaab') : 'Abwaab'
		// Re-apply the marker index.html stamps on the staging host: this runs
		// after settings resolve and would otherwise overwrite it, leaving the
		// two environments indistinguishable in the tab.
		document.title = isStagingHost() ? `[Staging] ${title}` : title
	}, [meta?.title])

	const resetAppMeta = () => {
		updateFavicon()
		updateDocumentTitle()
	}

	return { resetAppMeta }
}
